import { render } from "./RequestArtistAccount.vue?vue&type=template&id=486fc745&scoped=true"
import script from "./RequestArtistAccount.vue?vue&type=script&lang=js"
export * from "./RequestArtistAccount.vue?vue&type=script&lang=js"

import "./RequestArtistAccount.vue?vue&type=style&index=0&id=486fc745&scoped=true&lang=css"

import exportComponent from "/Users/juvicmartires/Documents/BreakingHits/breakinghits-vuejs-website/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-486fc745"]])

export default __exports__